(function () {
  console.log('subscription-bundle-dynamic unlock loaded');

  function run() {
    if (window.__plantinBabRebuyVisibleFixBound) return;
    window.__plantinBabRebuyVisibleFixBound = true;

    function removeStuckClass() {
      document.body.classList.remove('rebuy-cart-visible');
    }

    function handleCartClose(e) {
      var el = e.target;
      if (el && el.nodeType === 3) el = el.parentElement; // text node
      if (!el || !el.closest) return;

      if (
        !el.closest(
          '.as-close-btn, .rebuy-cart__flyout-close, .rebuy-cart__close, .rebuy-cart__close-button, .rebuy-cart__background, .rebuy-cart__shade, [data-rebuy-cart-close], .as-absolute.as-overflow-hidden'
        )
      ) {
        return;
      }

      removeStuckClass();
    }

    document.addEventListener('click', handleCartClose, true);
    document.addEventListener('touchend', handleCartClose, { capture: true, passive: true });
    // optional, modern browsers:
    document.addEventListener('pointerup', handleCartClose, true);
  }

  if (document.readyState === 'complete') {
    run();
  } else {
    window.addEventListener('load', run);
  }
})();
